import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "extension-communication" */ './lazyIndex')
);

export const lazyInitializeMessageCommunicationWithExtension = new LazyAction(
    lazyModule,
    m => m.initializeMessageCommunication
);

export { default as postMessageToParentExtension } from './utils/postMessageToParentExtension';
export * from './handlers/sendDownloadUrlToExtension';
export { default as sendLastUrlToExtension } from './handlers/sendLastUrlToExtension';
export { MessageRequestTypes } from './schema/RequestMessageTypes';
